import { ENROLLMENT_STATUS, PAYMENT_METHOD_CODE } from "consts";
import { type PolicyDetail } from "utils";
import { getPaymentMethodDetails } from "utils";

export const isEasyPayEnrolled = (
  userBilling?: PolicyDetail["userBilling"]
): boolean => {
  if (userBilling) {
    const { paymentMethod } = getPaymentMethodDetails(
      userBilling.accounting?.paymentPlan?.planType?.toLowerCase()
    );

    return paymentMethod.includes(PAYMENT_METHOD_CODE.EASYPAY);
  }
  return false;
};

export const isEasyPayPending = (
  userDetails?: PolicyDetail["userDetails"]
): boolean => {
  if (userDetails) {
    return (
      userDetails.insuredPreferences?.easyPayEnrollmentStatus ===
      ENROLLMENT_STATUS.PENDING
    );
  }
  return false;
};

export const isInvoiceMortgagee = (
  userBilling?: PolicyDetail["userBilling"]
): boolean => {
  if (userBilling) {
    const { paymentMethod } = getPaymentMethodDetails(
      userBilling.accounting?.paymentPlan?.planType?.toLowerCase()
    );

    return paymentMethod.includes(PAYMENT_METHOD_CODE.INVOICE);
  }
  return false;
};

export const isEasyPayEligible = (
  userBilling?: PolicyDetail["userBilling"],
  userDetails?: PolicyDetail["userDetails"]
): boolean => {
  if (userBilling && userDetails) {
    const isEnrolledInEasyPay = isEasyPayEnrolled(userBilling);
    const isPendingEasyPayEnrollment = isEasyPayPending(userDetails);
    const isInvoiced = isInvoiceMortgagee(userBilling);
    // Only allows active policies for paperless/easypay; this may change.
    const isActivePolicy = userDetails.policyStatus === "ACTIVEPOLICY";
    return (
      !isEnrolledInEasyPay &&
      !isInvoiced &&
      !isPendingEasyPayEnrollment &&
      isActivePolicy
    );
  }

  return false;
};

export const isEasyPayEnrolledOrPending = (
  userBilling?: PolicyDetail["userBilling"],
  userDetails?: PolicyDetail["userDetails"]
): boolean => {
  if (userBilling && userDetails) {
    return !isEasyPayEligible(userBilling, userDetails);
  }

  return false;
};
